import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="taggable"
export default class extends Controller {
  static targets = ["input"]
  static values = { tags: Array }

  connect() {
    console.log(this.tagsValue)
    let tagify = new Tagify(this.inputTarget, {
      whitelist: this.tagsValue,
      mode: 'select',
      delimiters: [',', 'Enter'],
      dropdown: {
        enabled: 0,
        maxItems: 100,
      }
    })

    tagify.on('blur', (e) => {
      console.log(e.detail.tagify.value);
      console.log(this.inputTarget);
      setTimeout(() => {
        this.inputTarget.value = e.detail.tagify.value[0].value;
      }, 10);
    })
    
    
  }
}
